<button
  *ngIf="actionsMenuModel.type == 'Single'"
  mat-icon-button
  matTooltip="Действия"
  matTooltipPosition="right"
  [matMenuTriggerFor]="menu"
  (click)="opened()"
  [disabled]="actionsMenuModel.isDisabled">
  <mat-icon>menu</mat-icon>
</button>
<button class="atp-table-actions-menu__multiple-button" *ngIf="actionsMenuModel.type == 'Multiple'" mat-raised-button
  [matMenuTriggerFor]="menu" (click)="opened()" [disabled]="actionsMenuModel.isDisabled">
  <mat-icon>menu</mat-icon>
  <span>Действия</span>
</button>
<mat-menu #menu="matMenu">
  <ng-container *ngFor="let item of items">
    <ng-container *ngIf="!item.isInvisible">
      <button *ngIf="!item.items" mat-menu-item (click)="item.action(model)">
        <mat-icon>{{item.icon}}</mat-icon>
        <span>{{item.name}}</span>
      </button>
      <atp-table-actions-submenu *ngIf="item.items" [actionMenuItem]="item" [model]="model"></atp-table-actions-submenu>
    </ng-container>
  </ng-container>
</mat-menu>
